import moment from "moment";
import Vue from "vue";
import { getStorage, uploadBytes, getDownloadURL, ref as refStorage } from "firebase/storage";
import { getDatabase, set, push, onValue, ref } from "firebase/database";
import { getFunctions, httpsCallable } from "firebase/functions";

import { GET_FILE, UPLOAD_FILE, UPLOAD_METADATA } from "../actions";
import { SET_KEY } from "../mutations";

const database = getDatabase();
const storage = getStorage();
const functions = getFunctions();

const state = {
  files: {},

  errors: null,
};

const getters = {};

const mutations = {
  [SET_KEY](state, { key, value }) {
    Vue.set(state, key, value);
  },
};

const actions = {
  async [GET_FILE]({ commit }, { key }) {
    const result = ref(database, `files/${key}`);

    onValue(result, (snapshot) => {
      const value = snapshot.val();
      commit(SET_KEY, { key, value });
    });
  },
  async [UPLOAD_METADATA](_, payload) {
    const uploadMetadataToPinata = httpsCallable(functions, "uploadMetadataToPinata");
    const { data } = await uploadMetadataToPinata(payload);

    console.log(data);
  },
  async [UPLOAD_FILE]({ rootGetters }, { file, ext }) {
    let status;
    let url;

    const { uid } = rootGetters["auth/currentUser"];
    const createdAt = moment().toISOString();

    const key = push(ref(database, `members/${uid}/files/audios`)).key;
    set(ref(database, `members/${uid}/files/audios/${key}`), { uploadedBy: uid, createdAt });

    try {
      const storageRef = refStorage(storage, `messages/audio/${uid}/${key}.${ext}`);

      const uploadTask = await uploadBytes(storageRef, file);
      url = await getDownloadURL(uploadTask.ref);

      status = "success";
    } catch (error) {
      console.log(error);
      status = "fail";
    }

    return { key, status, url };
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
